/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EPermis {
    B = 'B',
    AM = 'AM'
}


export function EPermisFromJSON(json: any): EPermis {
    return EPermisFromJSONTyped(json, false);
}

export function EPermisFromJSONTyped(json: any, ignoreDiscriminator: boolean): EPermis {
    return json as EPermis;
}

export function EPermisToJSON(value?: EPermis | null): any {
    return value as any;
}

